import { isTeamoji26RefreshEmojiPickerEnabled } from '../../util/teamoji26RefreshEmojiPicker';

export const isRefreshEmojiPickerEnabled = (): boolean => {
	return isTeamoji26RefreshEmojiPickerEnabled();
};
